import { render, staticRenderFns } from "./SendEgiftPanelLogos.vue?vue&type=template&id=1279447c&scoped=true"
import script from "./SendEgiftPanelLogos.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelLogos.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelLogos.vue?vue&type=style&index=0&id=1279447c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1279447c",
  null
  
)

export default component.exports